import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectOrganizationSelectedCounter = createSelector(
  [(store: RootState) => store.userProfileOrganization.selectedOrganizations],
  // Devuelve el listado de organizations seleccionados o asignados ordenados por nombre
  (data) => data.length
);